import { render, staticRenderFns } from "./MCQQuestion.vue?vue&type=template&id=55237bd6&scoped=true&"
import script from "./MCQQuestion.vue?vue&type=script&lang=js&"
export * from "./MCQQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MCQQuestion.vue?vue&type=style&index=0&id=55237bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55237bd6",
  null
  
)

export default component.exports